module.exports = __webpack_public_path__ + "static/img/valueadd13.fb826dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd13.png
// module id = t3Hm
// module chunks = 1